export const reducer = (state, action) => {
  switch (action.type) {
    case 'AUTHENTICATED':
      return {
        ...state,
        isInitialized: true,
        isAuthenticated: true,
      }
    case 'UNAUTHENTICATED':
      return {
        ...state,
        isInitialized: true,
        isAuthenticated: false,
      }
    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'CLEAR_ERROR':
      return {
        ...state,
        error: undefined,
      }
  }
}
